export class DeviceParamsLirisV3BoardType {

    public sensor : number;
    public extension : string;
}
